'use strict';

var distinctArray = require('./distinctArray.js');
var removeItemOnce = require('./removeItemOnce.js');

/**
 * Removes a value from a distinct array.
 *
 * @template T - The type of elements in the array (string or number).
 * @param {T[]} arr - The distinct array from which to remove the value.
 * @param {T} value - The value to remove from the array.
 * @returns {T[]} - The updated array with the value removed.
 */ function removeFromDistinctArray(arr, value) {
    return removeItemOnce(distinctArray(arr), value);
}

module.exports = removeFromDistinctArray;
